import { connect } from 'react-redux';
import compose from 'recompose/compose';
import DocumentHead from '../components/DocumentHead';
import onlyIf from '../hocs/onlyIf';
import { getDocumentHeadProps } from '../selectors/documentHead';
var shouldRender = function (_a) {
    var isLoading = _a.isLoading, isBasic = _a.isBasic;
    return !isLoading && !isBasic;
};
export default compose(connect(getDocumentHeadProps), onlyIf(shouldRender))(DocumentHead);
